import { api, apiFetch } from '@/api/client';

export interface FaseBestand {
  key: string;
  filename: string;
  size: number;
  lastModified: string | null;
  serveUrl: string;
}

export async function listFaseBestanden(projectId: number, faseId: number): Promise<{ files: FaseBestand[] }> {
  return api(`/api/projects/${projectId}/fases/${faseId}/bestanden`);
}

export async function uploadFaseBestand(
  projectId: number,
  faseId: number,
  file: File,
): Promise<{ key: string; filename: string; serveUrl: string }> {
  const fd = new FormData();
  fd.append('file', file);
  return api(`/api/projects/${projectId}/fases/${faseId}/bestanden`, { method: 'POST', body: fd });
}

export async function deleteFaseBestand(projectId: number, faseId: number, key: string): Promise<void> {
  await api(`/api/projects/${projectId}/fases/${faseId}/bestanden?key=${encodeURIComponent(key)}`, { method: 'DELETE' });
}

/**
 * Download a fase-bestand. The serve route is AUTHENTICATED (not the public
 * /photos/serve proxy), so a plain <a href> would 401 — we fetch with the auth
 * header via apiFetch, then trigger a browser download from the blob.
 */
export async function downloadFaseBestand(serveUrl: string, filename: string): Promise<void> {
  const res = await apiFetch(serveUrl);
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  try {
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    URL.revokeObjectURL(url);
  }
}
